module.exports = __webpack_public_path__ + "img/39.b60f5f64.svg";